module.exports = __webpack_public_path__ + "canny-hubspot-integration-b062cc64efbc0c67c751560ef3af7ab3.webp";